const BASE = "/api/agent/runs";

export async function listRuns({ sessionId, limit = 50 }) {
  const qs = new URLSearchParams({ session_id: String(sessionId), limit: String(limit) });
  const res = await fetch(`${BASE}?${qs}`, { credentials: "same-origin" });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.message || data.error || `HTTP ${res.status}`);
  return Array.isArray(data.runs) ? data.runs : [];
}
